// Tanggal simulasi uji coba — WAJIB paling awal, sebelum modul lain membaca jam.
import './utils/simulasi';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerSW } from './utils/pwa';
import { initAutoUpdate } from './utils/autoUpdate';
import { initDesktopMode } from './utils/desktopMode';

// Terapkan pilihan "Situs Desktop" tersimpan SEBELUM render (hindari kedip)
initDesktopMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker
registerSW();

// Auto-update device saat ada deploy baru (cek /version.json berkala)
initAutoUpdate();

